import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-echarts-header" }
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import { ref, reactive, onBeforeMount } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { getCurrentMonthDateRange } from '@/utils/timeFormat'
import CosRangePickerMonth from '@/components/CosRangePickerMonth/index.vue'
import { chanceSaleList as chanceSaleListFbu } from '@/api/gucangSales/index'
import { chanceSaleList as chanceSaleListLbu } from '@/api/yuntuSales/index'
import type { Ref, PropType } from 'vue'

const __default__ = { name: 'HomeBusinessAmountBarChart' }

interface QueryFormType {
  depCode: string
  startTime: string
  endTime: string
}
interface ItemCommonType {
  countTime: string
  salesAmount: number
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '商机金额'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const props = __props

// 函数枚举
const functionEnum = {
  cos_fbu: chanceSaleListFbu,
  cos_lbu: chanceSaleListLbu
}
const spinning = ref(false)
const showECharts = ref(false)
const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthDateRange()
const queryForm = reactive<QueryFormType>({
  depCode: 'all',
  startTime: firstDayOfMonth,
  endTime: lastDayOfMonth
})
const getData = () => {
  spinning.value = true
  functionEnum[props.appId](queryForm)
    .then((res) => {
      const data = res.data as unknown as ItemCommonType[]
      if (data.length === 0) {
        showECharts.value = false
        initChart([])
      } else {
        showECharts.value = true
        initChart(data)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: ItemCommonType[]) => {
  setOptions({
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['商机金额(万元)'],
      right: '50px'
    },
    toolbox: {
      feature: {
        magicType: {
          show: false,
          type: ['line', 'bar']
        }
      }
    },
    grid: {
      left: '80',
      right: '50',
      bottom: '50'
    },
    calculable: false,
    xAxis: [
      {
        type: 'category',
        data: data.map((item) => item.countTime)
        // axisLabel: {
        //   // 倾斜的程度
        //   formatter: function (value: any) {
        //     if (value.length > 7) {
        //       return `${value.slice(0, 7)}...`
        //     }
        //     return value
        //   }
        // }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLabel: {
          // 倾斜的程度
          margin: 2,
          formatter: function (value: any) {
            if (value >= 10000 && value < 100000000) {
              value = value / 10000 + '万'
            } else if (value >= 100000000 && value < 1000000000000) {
              value = value / 100000000 + '亿'
            } else if (value >= 1000000000000) {
              value = value / 1000000000000 + '兆'
            }
            return value
          }
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      }
    ],
    series: [
      {
        name: '商机金额(万元)',
        type: 'bar',
        itemStyle: {
          color: '#3F97FF'
        },
        data: data.map((item) => item.salesAmount)
      }
    ]
  })
}
onBeforeMount(() => getData())

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CosRangePickerMonth, {
          startTime: queryForm.startTime,
          "onUpdate:startTime": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.startTime) = $event)),
          endTime: queryForm.endTime,
          "onUpdate:endTime": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.endTime) = $event)),
          allowClear: props.allowClear,
          onChange: getData
        }, null, 8, ["startTime", "endTime", "allowClear"]),
        _createVNode(_component_CosSelect, {
          value: queryForm.depCode,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.depCode) = $event)),
          allowClear: props.allowClear,
          style: {"width":"145px","margin-left":"10px"},
          onChange: getData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select_option, { value: "all" }, {
              default: _withCtx(() => [
                _createTextVNode("全部数据")
              ]),
              _: 1
            }),
            _createVNode(_component_a_select_option, { value: "my" }, {
              default: _withCtx(() => [
                _createTextVNode("我的数据")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "allowClear"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})